<template>
  <div class="subModal scroll">
    <template v-if="arts.length > 0">
      <div class="item" v-for="(a, index) in arts" :key="index">
        <div class="title">{{ a.title }}</div>
        <div class="del" @click="setDel(a.id)"><i class="fa-solid fa-trash"></i></div>
      </div>
    </template>
    <template v-else>
      <div class="text-center px-4">
        <span class="text-sm">Nenhuma arte publicada.</span>
      </div>
    </template>

  </div>
</template>

<script setup>


import { ref } from 'vue'
import { useStore } from '@/stores/index.js'
import { deleteMyArt, getMyArts } from '@/services/api.js'

const emits = defineEmits(['textAlerta'])
const store = useStore()

const arts = ref([])

async function getArt() {
  try {
    const data = await getMyArts(store.initUser?.id)
    arts.value = data.records ?? []
  } catch (_) {
    emits('textAlerta', 'Erro ao carregar artes')
    arts.value = []
  }
}

async function setDel(id) {
  const alerta = confirm('Tem certeza?')
  if (alerta) {
    try {
      await deleteMyArt(id)
      emits('textAlerta', 'Arte removida!')
      await getArt()
    } catch (_) {
      emits('textAlerta', 'Erro ao remover arte')
    }
  }
}

getArt()

</script>

<style scoped>
.scroll {
  overflow: auto;
  position: relative;
  height: 260px;
}

.subModal .item {
  position: relative;
  float: left;
  width: 100%;
  height: 30px;
  padding: 0 10px;
  font-size: 14px;
  line-height: 30px;
  background-color: #EFF2F5;
  border-radius: 12px;
  margin-top: 6px;
}

.subModal .item .del {
  position: absolute;
  right: 10px;
  top: 0;
  width: 10px;
  height: 10px;
  font-size: 14px;
  font-weight: 600;
  z-index: 99;
}

</style>
